<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="total">
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-question sicon one"></i>
        <span class="tjContent">
          <div>点击人数</div>
          <div class="numText one">{{cdata.total.click_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-success sicon two"></i>
        <span class="tjContent">
          <div>成功人数</div>
          <div class="numText two">{{cdata.total.clickok_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>成功率</div>
          <div class="numText three">{{cdata.total.clickok_per||'0'}}%</div>
        </span>
      </el-card>
    </el-row>

    <el-row class="selectRow">
      <el-col :sm="12" xs:="24">
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" id="seven" plain @click="changeDate(1)">昨天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)">最近7天</el-button>
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-row>
      </el-col>
      <el-col :sm="12" xs:="24" style="float:right;min-width:150px; text-align: right;">
        <el-row :gutter="10">
          <el-button class="xs24" type="primary" round @click="toogleChart">图表</el-button>
          <el-dropdown class="dropdown xs24" @command="themeFilter">
            <el-button type="normal" class="dropdown">
              {{tText}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="dropdown-menu xs24">
              <el-dropdown-item command>所有类型</el-dropdown-item>
              <el-dropdown-item v-for="(v,i) in config" :key="i" :command="i">{{v[0]}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-input
            style="width:170px"
            @clear="getList"
            @keyup.enter.native="search"
            ref="input"
            class="search xs24"
            v-model="pdata.kw"
            clearable
            placeholder="请输入小程序名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
        </el-row>
      </el-col>
    </el-row>
    <!-- 图表 -->
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <el-table
      class="addata"
      :data="cdata.list"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="space_id"
      @expand-change="expands"
    >
      <el-table-column type="expand" prop="name">
        <template slot-scope="s">
          <!-- 折叠 -->
          <el-table :data="s.row.exData" :show-header="false" row-key="space_id">
            <el-table-column prop="d_date" label="日期" align="center" width="100px"></el-table-column>
            <el-table-column prop="name" label="广告位名称" align="left">
              <template slot-scope="scope">
                <span>{{scope.row.name+'-'+scope.row.type_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="小程序名称" align="left"></el-table-column>
            <el-table-column prop="type_name" label="广告位类型" align="center"></el-table-column>
            <el-table-column prop="click_uv" label="点击人数" align="center"></el-table-column>
            <el-table-column prop="clickok_uv" label="成功人数" align="center"></el-table-column>
            <el-table-column prop="clickok_per" label="点击率" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.clickok_per+'%'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"></el-table-column>
          </el-table>
          <!-- 折叠结束 -->
        </template>
      </el-table-column>
      <el-table-column prop="space_id" label="ID" width="100px" align="center"></el-table-column>
      <el-table-column prop="name" label="广告位名称" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.name+'-'+scope.row.type_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="小程序名称" align="left"></el-table-column>
      <el-table-column prop="type_name" label="广告位类型" align="center"></el-table-column>
      <el-table-column
        prop="click_uv"
        sortable
        :sort-method="(a,b)=>{return (a.click_uv-0)-(b.click_uv-0)}"
        label="点击人数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_uv"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_uv-0)-(b.clickok_uv-0)}"
        label="成功人数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="clickok_per"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_per-0)-(b.clickok_per-0)}"
        label="点击率"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{scope.row.clickok_per+'%'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="showDia(scope.row.space_id)">更多</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
    <el-dialog title="广告位详情" :visible.sync="editDialog">
      <el-table :data="list" stripe row-key="id">
        <el-table-column prop="name" label="推广产品" align="left"></el-table-column>
        <el-table-column prop="click_uv" label="点击人数" align="center"></el-table-column>
        <el-table-column prop="clickok_uv" label="成功人数" align="center"></el-table-column>
        <el-table-column prop="clickok_per" label="点击率" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.clickok_per+'%'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { saddata, saddetail, addataEx } from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        kw: "",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-01",
        // edate: "2019-04-01"
      },
      tText: "请选择广告位类型",
      maxPage: 1,
      config: [],
      list: [],
      editDialog: false,

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["点击人数", "点击成功数", "点击率"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "点击人数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击成功数",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "点击率",
            type: "line",
            smooth: true,
            data: []
          }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      }
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      saddata(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
        	
          if (res.data.list!=null&&res.data.list.length > 0) {
            res.data.list.forEach(x => {
              x.exData = [];
            });
          }
  
          this.cdata = res.data;
          this.maxPage = res.data.max_page;
          this.option.xAxis.data = res.data.chart.date;
          this.option.series[0].data = res.data.chart.click_uv;
          this.option.series[1].data = res.data.chart.clickok_uv;
          this.option.series[2].data = res.data.chart.clickok_per;
          this.drawColumnChart();
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter(s) {
      this.tText = s === "" ? "请选择广告位类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    },
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    showDia(id) {
      this.editDialog = true;
      var p =
        "space_id=" +
        id +
        "&sdate=" +
        this.pdata.sdate +
        "&edate=" +
        this.pdata.edate;
      saddetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.list = res.data.list;
        }
      });
    },
    toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    },
    expands(r, es) {
      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.creative_id == r.creative_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `space_id=${r.space_id}&sdate=${this.dateVal[0]}&edate=${
          this.dateVal[1]
        }`;
        addataEx(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
          }
        });
      }
    }
  },

  mounted() {
    this.getConfig();
    this.getList();
    document.getElementById("seven").focus();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>
<style >
.total {
  min-width: 1200px;
  padding: 15px 30px;
  background: #f2f6fc;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
}
.box-card {
  float: left;
  width: 260px;
  margin-right: 20px;
}
.sicon {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 10px;
  border-radius: 10px;
  background: #67c23a;
  text-align: center;
  font-size: 25px;
  color: white;
}
.sicon.one {
  background: #67c23a;
}
.sicon.two {
  background: #e6a23c;
}
.sicon.three {
  background: #f56c6c;
}
.sicon.four {
  background: #909399;
}

.tjContent {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  margin-left: 10px;
}
.tjContent > div {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
}

.tjContent > div.numText {
  font-size: 30px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: brown;
}
.tjContent > div.numText.one {
  color: #67c23a;
}
.tjContent > div.numText.two {
  color: #e6a23c;
}
.tjContent > div.numText.three {
  color: #f56c6c;
}
.tjContent > div.numText.four {
  color: #909399;
}
</style>





// WEBPACK FOOTER //
// adData.vue?71c8a376